export const devarshKnowledgeBase = {
  personal: {
  fullName: "Devarsh Wali",
  preferredName: "Dev",
  age: "he's young",
  dob: "April 25, 1998",
  nationality: "Indian",
  currentLocation: "Baltimore, MD (Willing to relocate)",
  credentials: "Devarsh Wali, M.S., PMP®",
  certifications: "Project Management Professional (PMP)®, IBM AI Product Manager, Google IT Automation with Python, Google AI",
  passions: "Outside of work, he channels his curiosity into building AI and LLM-powered MVPs on Replit, automating complex tasks and turning bold ideas into working products fast.",
  contactEmail: "devarshwali@gmail.com",
  linkedin: "linkedin.com/in/devarshwali",
  instagram: "@devarshwalimagic",
  languages: ["English (Fluent)", "Hindi (Native)", "Gujarati (Native)"],
  interests: ["AI/LLM building", "Magic performances", "Product strategy", "Startups", "Rubik's cube", "Travel"]
  },

  education: {
  masters: {
  degree: "Master of Science in Engineering Management",
  university: "UMBC (University of Maryland, Baltimore County)",
  gpa: "3.87",
  graduation: "December 2025",
  coursework: [
    "ENMG 652 – Management, Leadership & Communication",
    "ENMG 658 – Financial Management",
    "ENMG 680 – International Project Management",
    "ENMG 650 – Project Management Fundamentals",
    "ENMG 664 – Quality Engineering & Management",
    "ENMG 691 – Operations & Supply Chain Management",
    "ECEP 405 – Global Engineering",
    "ENMG 656 – Engineering Law & Ethics",
    "ENMG 663 – Advanced Project Management",
    "ENMG 693 – Management Project (in progress)"
  ],
  leadership: "President of Product Management Club at UMBC, built the university's largest student community from ground up",
  hackathon: "Organized Product Hackathon with 60+ teams"
  },
  bachelors: {
  degree: "Bachelor of Engineering (Electrical Engineering)",
  university: "Pune University",
  usEquivalent: "Bachelor of Science",
  coreCourses: [
    "Electrical Machines", "Power Systems", "Control Systems",
    "Microprocessors & Microcontrollers", "Digital Signal Processing",
    "Electrical Measurements & Instrumentation", "Engineering Mathematics",
    "Project Management"
  ]
  }
  },

  workExperience: [
  {
  company: "Mindset Copilot",
  industry: "EdTech / B2B SaaS",
  role: "AI Product Manager (Contract)",
  period: "Mar 2026 - Aug 2026",
  achievements: [
    "Piloted the MVP with 3 schools, reaching a hallucination rate under 2% and 95% product adoption, using AI eval criteria with human review loops that track output accuracy, relevance, hallucination risk and user friction",
    "Owned AI product strategy for K-5 literacy assessment workflows used by district schools, translating feedback from district leaders, literacy coaches and educators into product requirements, pilot priorities and MVP decisions",
    "Partnered with the CEO, CTO and CLO to build a 0-to-1 assessment support product, defining educator personas, problem statements, insight workflows and AI-driven recommendations from learner results",
    "Shipped an MVP in 3 weeks by running rapid customer discovery, testing educator workflows and translating evolving priorities into prototype flows, prompt logic and AI guided user journeys using Replit",
    "Built AI evaluation agents using LangGraph to assess weak activity outputs, improve prompt quality and keep teacher recommendations relevant, explainable and aligned to literacy assessment outcomes",
    "Designed a human-in-the-loop agentic PM workflow using LangGraph, Granola/Zoom transcripts and Jira MCP to turn customer calls into prioritized Jira tasks, decision logs, risk flags and owner follow-ups",
    "Supported pilot planning, customer demos and go-to-market messaging by connecting product capabilities to district pain points, literacy outcomes and educator workflows",
    "Used customer feedback, usage signals and competitive analysis to refine scope, prioritize roadmap decisions and support pricing and packaging inputs for district school adoption"
  ],
  metrics: [{ value: "<2%", label: "Hallucination Rate" }, { value: "95%", label: "Product Adoption" }, { value: "3 Schools", label: "Pilot MVP" }, { value: "3 Weeks", label: "MVP Shipped" }],
  tools: ["LangGraph", "Replit", "AI Eval Criteria", "Prompt Engineering", "Replit Prototyping", "Jira MCP"],
  whyItMatters: "0-to-1 AI product work in EdTech, shipped MVP in 3 weeks, built AI evaluation agents and led K-5 literacy assessment strategy for district school pilots."
  },
  {
  company: "Presence",
  industry: "EdTech / B2B SaaS",
  role: "MBA Fellow (Product & Strategy)",
  period: "Oct 2025 - Dec 2025",
  achievements: [
    "Automated weekly Leadership Team metrics reporting, saving 200+ hours per month through Excel VBA and Tableau dashboards",
    "Owned product discovery for ML-driven model for student referral routing and partnered with data science on evaluation criteria",
    "Improved clinician onboarding completion from 54% to 66% through iterative workflow redesign and experimentation",
    "Built SQL and Tableau dashboards to track activation, adoption and operational performance across key product journeys",
    "Translated ambiguous user and operational pain points into product requirements, success metrics and backlog priorities",
    "Partnered with cross-functional stakeholders to improve user experience in complex service delivery and onboarding workflows"
  ],
  metrics: [{ value: "200+ hrs/mo", label: "Reporting Time Saved" }, { value: "54% to 66%", label: "Onboarding Completion" }, { value: "$100M+", label: "ARR SaaS Product" }],
  tools: ["SQL & Tableau", "ML Discovery", "Product Requirements", "Onboarding Optimization", "Cross-functional Partnering"],
  whyItMatters: "Series D HealthTech PM work: automated leadership reporting (200+ hrs/month saved), ML-driven referral routing discovery, and onboarding completion improved from 54% to 66%."
  },
  {
  company: "UMBC",
  industry: "EdTech / Higher Education",
  role: "Program Manager",
  period: "Jan 2025 - Dec 2025",
  achievements: [
    "Launched a career support chatbot for 10K+ students and established a framework of 12+ A/B tests, KPIs and event tracking, achieving 92% NPS from students and advisors",
    "Led student placement improvements with the Career Center across employer outreach, career fairs, advising handoffs",
    "Ran product discovery with students, career advisors and administrators to define job placement bottlenecks and success criteria",
    "Established chatbot KPIs, event tracking to spot student drop-offs and an experimentation framework, enabling A/B tests",
    "Partnered with IT team to launch a career support chatbot for 10k+ students, defining intents, routing, escalations and permissions",
    "Mapped end-to-end workflows and translated needs into clear product requirements, user stories and acceptance criteria",
    "Drove rollout through training, user acceptance testing (UAT) and post-launch ticket triage, iterating based on customer feedback"
  ],
  metrics: [{ value: "10K+", label: "Students Supported" }, { value: "12+", label: "A/B Tests" }, { value: "92%", label: "NPS Achieved" }],
  tools: ["AI Workflow Mapping", "Chatbot Requirements", "Product Discovery", "KPIs & Event Tracking", "UAT", "A/B Testing"],
  whyItMatters: "Applied product and program management skills to AI implementation at a university, launched career support chatbot for 10k+ students."
  },
  {
  company: "Barclays",
  industry: "FinTech / B2B2C SaaS",
  role: "Product Manager",
  period: "Mar 2023 - Jan 2024",
  achievements: [
    "Lifted NPS +7.6 points by redesigning compliance-aware IVR workflows with intent matching and skills-based routing, reducing wait times and wrong transfers",
    "Led agile ceremonies and sprint planning across 3 globally distributed scrum teams, owning the product roadmap and backlog prioritization while ensuring alignment with business requirements",
    "Implemented standardized AI-powered monitoring and analytics across 35+ global business units, enabling consistent performance tracking and unified reporting to drive operational efficiency",
    "Owned product strategy for payment operations and disbursement workflows supporting $110M+ in payment volume across U.S. and U.K. markets, balancing regulatory, technical and commercial constraints",
    "Aligned competing stakeholder priorities by delivering actionable, data-driven insights in monthly reports and analyzing Tableau dashboard trends in caller metrics"
  ],
  metrics: [{ value: "+7.6", label: "NPS Lift" }, { value: "3", label: "Scrum Teams Led" }, { value: "35+", label: "Business Units" }, { value: "$110M+", label: "Payment Volume" }],
  tools: ["IVR Design", "Intent Matching", "Skills-Based Routing", "Agile/Scrum Leadership", "AI-Powered Monitoring", "SQL & Tableau"],
  whyItMatters: "Enterprise PM at a global bank, lifted NPS +7.6 points via compliance-aware IVR redesign, led 3 distributed scrum teams, and rolled out AI-powered monitoring across 35+ business units."
  },
  {
  company: "BYJU'S",
  industry: "EdTech / B2C SaaS",
  role: "Product Manager",
  period: "Aug 2021 - Mar 2023",
  achievements: [
    "Launched BYJU'S English 0 to 1, scaled it to $1.2M+ monthly revenue in 10 months, owning roadmap, GTM and retention analytics",
    "Managed 14 person cross-functional squad across Design, Engineering, Data Science, Sales, Marketing and Content teams",
    "Owned Mixpanel analytics across products and built Tableau dashboards to monitor usage, retention, engagement and NPS trends"
  ],
  metrics: [{ value: "$1.2M+", label: "Monthly Revenue" }, { value: "14", label: "Person Squad" }, { value: "100M+", label: "Registered Learners" }],
  tools: ["Mixpanel", "Tableau", "A/B Testing", "GTM Strategy", "Retention Analytics", "Cross-functional Leadership"],
  whyItMatters: "Unicorn EdTech PM, launched BYJU'S English 0 to 1, scaled to $1.2M+ MRR in 10 months, managed 14-person cross-functional squad."
  },
  {
  company: "Opportune Hospitality Services",
  industry: "PropTech / B2B SaaS",
  role: "Software Engineer",
  period: "Jan 2019 - May 2021",
  achievements: [
    "Built PowerBI dashboards and event tracking to monitor adoption and churn, scaling the SaaS platform to $60K+ ARR with 94%+ app NPS",
    "Served as the tech lead for engineering 20+ core workflow launches, aligning stakeholders and delegating tasks within team",
    "Mapped hotel operations and maintenance workflows, translating manual service requests into digital ticketing, technician assignment and escalation flows across the property management platform"
  ],
  metrics: [{ value: "20+", label: "Features Launched" }, { value: "94%+", label: "App NPS" }, { value: "$60K+", label: "ARR Scaled" }],
  tools: ["API Integration", "CRM Systems", "Workflow Mapping", "Digital Ticketing", "Sprint Planning"],
  whyItMatters: "Software engineer and tech lead at a PropTech SaaS with a PM mindset: 20+ core workflow launches, manual hotel ops turned into digital workflows, platform scaled to $60K+ ARR with 94%+ app NPS."
  },
  {
  company: "Harbinger Lane",
  industry: "Volunteer Consulting / Product Strategy",
  role: "Volunteer Product Consultant - GTM Strategy",
  period: "Feb 2024 - May 2024",
  isVolunteer: true,
  achievements: [
    "Volunteered as a product consultant for an early-stage venture, conducting competitive market research and building a full GTM strategy covering positioning, pricing, target segments and launch messaging - done pro bono alongside full-time grad coursework",
    "Authored detailed PRDs through 6 stakeholder interviews and 200+ user surveys, translating ambiguous discovery findings into structured product requirements"
  ],
  metrics: [{ value: "6", label: "Stakeholder Interviews" }, { value: "200+", label: "User Surveys" }],
  tools: ["Competitive Research", "GTM Strategy", "PRD Writing", "Stakeholder Interviews", "Market Positioning"],
  whyItMatters: "Volunteer consulting engagement, full GTM strategy and PRD development through structured discovery (6 stakeholder interviews, 200+ surveys) - unpaid project work taken on during grad school."
  },
  {
  company: "PeerTeach",
  industry: "Volunteer / EdTech B2C SaaS",
  role: "Volunteer Product Marketing Advisor",
  period: "Aug 2024 - Dec 2024",
  isVolunteer: true,
  achievements: [
    "Volunteered as a product marketing advisor for an early-stage EdTech startup, owning GTM and growth strategy and reporting directly to the CEO",
    "Drove 220% social growth across LinkedIn, Instagram and YouTube over 10 weeks through consistent posting and experimentation",
    "Built Tableau dashboards for cross-functional performance tracking",
    "Partnered with Sales and Engineering on enablement and launch messaging"
  ],
  metrics: [{ value: "220%", label: "Social Growth" }, { value: "10 Weeks", label: "Timeframe" }, { value: "CEO", label: "Reports To" }],
  tools: ["GTM Strategy", "Social Media Growth", "Tableau", "Sales Enablement", "Launch Messaging"],
  whyItMatters: "Volunteer product marketing leadership at an early-stage EdTech startup, drove 220% social growth in 10 weeks reporting directly to the CEO - unpaid advisory work."
  },
  {
  company: "Perplexity",
  industry: "Volunteer / AI Consumer Tech",
  role: "Campus Ambassador Program Fellow",
  period: "Aug 2024 - Mar 2025",
  isVolunteer: true,
  achievements: [
    "Selected for a competitive, selective Campus Ambassador cohort for Perplexity AI, running product demos, workshops and adoption campaigns for the AI search product on campus",
    "Drove student awareness and adoption through campus events and social content, serving as a direct feedback channel between student users and Perplexity's product team",
    "Balanced the fellowship with full-time MS coursework and multiple other volunteer product commitments"
  ],
  metrics: [{ value: "Selective", label: "Cohort" }, { value: "8 Months", label: "Duration" }],
  tools: ["Community Building", "Product Evangelism", "Campus Marketing", "User Feedback Loops"],
  whyItMatters: "Volunteer brand ambassador role for a leading AI search company - hands-on product evangelism and community-building experience with a fast-moving consumer AI product."
  }
  ],

  projects: [
  {
  name: "TutorWeights - AI Tutor Eval",
  description: "An evaluation tool that tests whether an AI tutor actually teaches before it launches. It simulates multi-turn student conversations from personas, hidden misconceptions and topics, using synthetic scenarios only and no real student data.",
  role: "Product Manager & Builder",
  highlights: ["0-100 launch readiness score", "7-part pedagogy rubric", "Demo: baseline prompt 47, guarded prompt 95"],
  details: "Scores every conversation on seven dimensions: correctness, scaffolding, misconception handling, over-answer control, tone, age appropriateness and safety. Results roll up into a 0 to 100 launch readiness score with failure tags and prioritized fixes, and it is rerun after every prompt change to catch regressions. Built with Next.js, TypeScript and SQLite, rubric-based LLM scoring through the Anthropic and OpenAI APIs, and a synthetic scenario engine. There is an interactive demo on the portfolio's Projects section where you can flip between a baseline prompt (hands over the answer, scores 47) and a guarded prompt (scores 95)."
  },
  {
  name: "AppliFirst",
  description: "A live, full-stack agentic SaaS for job seekers: a real-time job board plus a Kanban application pipeline, with AI resume tailoring and analysis and a Chrome extension for one-click capture.",
  role: "Product Manager & Builder",
  highlights: ["20+ features shipped", "AI resume analyzer", "Chrome Extension (Manifest V3)", "Live product"],
  details: "Built on Replit with React, TypeScript, Node/Express, PostgreSQL and Drizzle ORM. Integrated the OpenAI API to turn unstructured inputs into structured outputs (job summaries, resume tailoring and analysis) with deterministic schemas, guardrails and human review steps. Added secure auth and ingestion endpoints and event tracking to measure activation and drop-offs, then iterated weekly on what the data said. It is live and linked from the Projects section."
  },
  {
  name: "ProdigyQuest",
  description: "A gamified K-12 learning platform that makes studying addictive and effective through personalized learning paths, progress tracking and AI-driven feedback.",
  role: "Product Manager & Builder",
  highlights: ["500+ users in week 1", "85% retention", "0-to-1 beta launch"],
  details: "Solves low engagement in traditional e-learning by embedding game mechanics and adaptive challenges. Acquired 500+ early users in the first week by leveraging a social media following and growth expertise, then ran user feedback cycles to refine retention features and learning outcomes. Stack: React, Node.js, Express, MongoDB, Firebase and the OpenAI API."
  },
  {
  name: "Muvely",
  description: "A HealthTech, AI-powered 3D motion-tracking fitness app delivering real-time posture correction through computer vision and personalized workout algorithms.",
  role: "Founder - led a 3-member team from concept to MVP, secured $2,500 seed funding, won 3rd place at CBIC Pitch Night",
  highlights: ["3-member team", "$2,500 seed funding", "3rd place at CBIC Pitch Night", "2,500+ early users"],
  details: "Built natively for iOS with Swift, Core ML, ARKit and computer vision. Delivered real-time posture correction and personalized workouts to 2,500+ early users."
  },
  {
  name: "Hybrid Electric Vehicle Performance Research",
  description: "Published IEEE research paper on performance optimization of hybrid electric vehicles through advanced control algorithms.",
  role: "Lead Researcher",
  highlights: ["IEEE published", "15% efficiency gain", "MATLAB and Simulink"],
  details: "Analyzed energy management systems and their impact on vehicle efficiency using MATLAB, Simulink, control systems and optimization algorithms."
  }
  ],

  coreSkills: {
  productBusiness: [
  "Product Strategy & Roadmapping",
  "Go-to-Market Strategy",
  "Data-Driven Decision Making",
  "A/B Testing & Experimentation",
  "User Experience Research",
  "Stakeholder Management",
  "Cross-functional Leadership",
  "Agile/Scrum Methodologies",
  "PRD Development",
  "Sales Enablement",
  "Messaging & Positioning",
  "Competitive Analysis",
  "Market Sizing (TAM/SAM/SOM)",
  "OKR & KPI Framework Design"
  ],
  technicalAI: [
  "AI/ML Integration",
  "Agentic AI",
  "Python Programming",
  "SQL & Database Management",
  "API Development",
  "System Architecture",
  "Process Automation",
  "Building LLM-powered MVPs on Replit",
  "Prompt Engineering & Prompt Fine-Tuning",
  "NLP (Natural Language Processing)",
  "RAG (Retrieval-Augmented Generation)",
  "AI Evals"
  ],
  dataAnalysis: ["SQL", "Tableau", "Power BI", "Microsoft Excel (advanced modeling)", "Salesforce CRM", "Google Analytics"],
  toolsPlatforms: ["Jira", "ChatGPT", "Claude", "Figma", "LangGraph", "n8n", "Salesforce", "Replit", "Google AI Studio", "Notion", "AWS", "Azure"],
  creative: [
  "Performance magic (500+ live shows)",
  "Creative problem-solving through storytelling",
  "Social media content creation and engagement",
  "Public speaking & presentations"
  ]
  },

  keyMetrics: {
  mauScaled: "100M+ Registered Learners (BYJU'S)",
  mrr: "$1.2M+ Monthly Recurring Revenue (0 to 1 product)",
  abTests: "12+ A/B tests tied to growth outcomes",
  npsLift: "+7.6 NPS improvement",
  automationSavings: "200+ hrs/mo saved through automation",
  onboardingLift: "54% to 66% onboarding improvement",
  paymentVolume: "$110M+ payment volume managed",
  mlPrecision: "81% to 87% ML precision (20M+ MAUs)",
  mvpShipped: "3-week MVP shipped",
  hallucinationRate: "<2% hallucination rate",
  productAdoption: "95% product adoption",
  arpScaling: "$60K+ ARR SaaS scaled",
  appNps: "94%+ app NPS (Opportune)",
  umbcNps: "92% NPS on the UMBC career chatbot",
  weeklyReporting: "200+ hrs/mo of leadership reporting automated (Presence)"
  },

  leadershipStyle: {
  approach: "Vision-driven, adaptable, and empathetic",
  focus: "Sustainable growth and shared team goals",
  inspiration: "Through clarity of vision and real-time problem solving",
  balance: "Analytical decision-making with emotional intelligence",
  communication: "Translates complex technical concepts into business language stakeholders understand",
  conflict: "Addresses disagreements with data and user evidence rather than opinions",
  mentoring: "Actively mentors junior team members and builds inclusive team cultures"
  },

  achievements: [
  {
  title: "Outstanding Graduate Student Organization Award Winner (May 2024)",
  org: "President, Product Management Club (UMBC)",
  details: "Built UMBC's largest student community from the ground up, growing membership from 10 to 500+. Organized a Product Hackathon with 60+ teams, ran monthly PM workshops with 30+ attendees each, and hosted 12 industry workshops."
  },
  {
  title: "Guest Speaker - Fashion & Lifestyle Retail Convention (Apr 2023)",
  details: "Invited to speak on digital transformation in retail and fintech innovation, alongside leaders from BharatX and other startups, to an audience of retail executives and entrepreneurs. The event drew 80+ startups, 20+ sponsors, 200+ total participants and 5+ Fortune 500 companies."
  },
  {
  title: "Top Sales Associate - BYJU'S",
  details: "Ranked #1 for 5 consecutive cycles among 8,000+ peers in the north region."
  }
  ],

  personality: {
  magic: "Performed 500+ live magic shows, building presentation skills and audience engagement expertise",
  innovation: "Constantly exploring AI tools and emerging technologies for practical business applications",
  creativity: "Combines analytical thinking with creative problem-solving approaches",
  quirks: "Can solve a Rubik's cube while explaining product strategy",
  builder: "Loves building AI and LLM-powered MVPs on Replit in free time, automating complex tasks",
  empathy: "Deep customer empathy from 2,500+ product demos and countless user interviews",
  resilience: "Moved from India to the US for grad school, adapted to new culture while maintaining top academic performance",
  humor: "Brings levity to serious product discussions believes the best teams laugh together"
  },

  availability: {
  status: "Open to full-time Product Manager roles and available to start now",
  location: "Baltimore, MD - Open to relocation",
  visa: "Authorized to work in the U.S. on OPT no sponsorship needed",
  sponsorship: "No sponsorship needed",
  preferredRoles: ["Product Manager", "Senior Product Manager", "Technical Product Manager", "Growth Product Manager", "Product Marketing Manager"],
  industries: ["HealthTech", "FinTech", "EdTech", "SaaS", "AI/ML", "Consumer Tech"],
  workStyle: "Thrives in fast-paced, high-ownership environments. Equally effective in startups and large enterprises."
  },

  whyDevarsh: {
  forStartups: "He's built 0-to-1 products, secured funding, and knows how to move fast with limited resources. His BYJU'S BD experience means he understands users at a visceral level from 2,500+ demos.",
  forEnterprise: "He's managed complex stakeholder landscapes at Barclays, shipped features through rigorous processes, and moved enterprise metrics (NPS, activation) with data-driven iteration.",
  forAICompanies: "He builds LLM-powered MVPs himself, understands prompt engineering and RAG architectures, and can bridge the gap between AI capabilities and user needs.",
  forGrowthRoles: "220% social growth, 22% churn reduction, 14% activation lift, 20+ A/B tests he's driven measurable growth at every stop.",
  overall: "Rare combination of technical depth (builds AI prototypes), business acumen (drove $220K revenue), and creative communication (500+ magic shows). Most PMs have one of these; Dev has all three."
  },

  recommendations: {
  summary: "Has strong recommendations from colleagues and managers across multiple companies",
  themes: ["Strategic thinking", "Cross-functional collaboration", "Data-driven approach", "Rapid execution", "Strong communication"]
  },

  conversationalFacts: {
  yearsOfExperience: "Devarsh has worked across paid roles at Opportune, BYJU'S, Barclays, Presence, UMBC, and Mindset Copilot, plus volunteer product work at Harbinger Lane, PeerTeach, and Perplexity along the way. That spans HealthTech, EdTech, FinTech, Consulting, Hospitality, and AI/Agentic workflows.",
  totalCompanies: "He's held 6 paid roles: Opportune Hospitality, BYJU'S, Barclays, Presence, UMBC (as Program Manager/Graduate Assistant), and Mindset Copilot. Alongside grad school, he also volunteered on product work at Harbinger Lane and PeerTeach, plus a Perplexity Campus Ambassador fellowship - real, shipped work, just unpaid.",
  whyProductManagement: "Dev started with an Electrical Engineering degree, but his real turning point was spending 9 months at BYJU'S doing 2,500+ product demos. Every day he was talking to real users parents, students, teachers understanding exactly why people use products the way they do. That user obsession never left him. He formalized it into product management and hasn't looked back since.",
  nationality: "Dev is originally from India. He moved to the US specifically to pursue his Master's degree at UMBC in Maryland. He speaks English fluently, plus Hindi and Gujarati natively.",
  proudestAchievement: "Dev's genuinely humble about it, but scaling to 100M+ users at BYJU'S is the kind of number that puts things in perspective. Most recently, shipping a 0-to-1 AI MVP in 3 weeks at Mindset Copilot is a highlight. He'd also mention founding Muvely, getting it Top 3 at the startup competition, and securing seed funding from scratch.",
  whatMakesHimUnique: "Most product managers are strong in one dimension strategy, execution, or communication. Dev has all three plus the technical depth to build prototypes himself. He's scaled 100M+ user products, codes his own AI tools, and has performed 500+ live magic shows. That combination genuinely doesn't show up on most resumes.",
  careerJourney: "Dev started in business development at BYJU'S doing 2,500+ product demos, transitioned into formal product management through BYJU'S APM → Barclays PM. Alongside full-time grad school at UMBC, he volunteered on product work at Harbinger Lane (GTM consulting), PeerTeach (product marketing), and a Perplexity Campus Ambassador fellowship - then landed the Presence MBA Fellowship and the Mindset Copilot AI PM contract. He's done GTM, consulting, enterprise PM, startup marketing, and agentic AI all before 27, including a stretch where he was volunteering on multiple product projects simultaneously while finishing his degree.",
  workStyle: "Dev thrives in high-ownership environments. He's equally at home in enterprise (Barclays, BYJU'S) and early-stage or volunteer settings (PeerTeach, Harbinger Lane, Muvely). He moves fast, uses data to back every decision, and took on multiple unpaid product projects simultaneously with grad school just to keep building - that kind of initiative doesn't show up as a line on a resume.",
  currentFocus: "Dev graduated in December 2025 and is actively looking for full-time Product Manager opportunities (his most recent role was the AI PM contract at Mindset Copilot, Mar to Aug 2026). He's on OPT no sponsorship needed and can start immediately. He's targeting PM, Senior PM, Technical PM, and Growth PM roles across HealthTech, FinTech, EdTech, and AI/ML companies.",
  strengths: "His biggest strengths are cross-functional leadership, data-driven decision making, and actually understanding the technical side of what he's building. He can have deep conversations with engineers AND executives that translation skill is genuinely rare.",
  biggestImpact: "The standout numbers: 100M+ registered learners scaled at BYJU'S, a 0-to-1 AI MVP shipped in 3 weeks at Mindset Copilot, +7.6 NPS lift at Barclays, 200 hrs/mo saved in automation at Presence, $220K revenue from 2,500+ demos, and 22% drop-off reduction through nudging experiments.",
  ageBirthday: "Dev was born on April 25, 1998 so he's 27. Young for the experience level he's at.",
  educationSummary: "MS in Engineering Management from UMBC with a 3.87 GPA, graduated December 2025. Bachelor of Engineering in Electrical from Pune University, India. At UMBC he was President of the Product Management Club and won the Outstanding Graduate Student Organization Award.",
  aiBuilderFact: "Dev doesn't just talk about AI he builds with it. He's created LLM-powered MVPs on Replit, built RAG pipelines, done prompt engineering, and has hands-on agentic workflow experience from Mindset Copilot, where he shipped a 0-to-1 AI MVP in 3 weeks and built LangGraph evaluation agents. He also built TutorWeights, a tool that scores AI tutors on a seven-part pedagogy rubric before they launch.",
  magicFact: "The magic thing isn't just a fun fact 500+ live shows means Dev has built real-world skills in reading audiences, building narrative tension, and keeping people engaged. Those translate directly into how he runs product demos and stakeholder presentations.",
  hobbies: "Dev performs live magic shows (500+ and counting), builds AI and LLM-powered MVPs on Replit for fun, and can solve a Rubik's cube while explaining a product roadmap. He genuinely does the AI building as a hobby automating complex tasks and turning bold ideas into working products fast.",
  contactInfo: "Best way to reach Dev: devarshwali@gmail.com or LinkedIn at linkedin.com/in/devarshwali. There's also a 'Book a 1:1' button right on this portfolio page that opens a pre-drafted Gmail.",
  salaryExpectations: "Dev is open to a conversation on compensation, which depends on role, location, level, and responsibilities. Share your budget range and he can confirm directly if it aligns.",
  industryExperience: "Dev has genuine experience across six distinct sectors: HealthTech (Presence), EdTech (BYJU'S, PeerTeach), FinTech (Barclays), AI/Agentic AI (Mindset Copilot), Consulting (Harbinger Lane), and Hospitality SaaS (Opportune). Cross-industry perspective is a real differentiator he spots patterns others miss."
  }
};

export const commonQuestions = [
  "Tell me about Devarsh's experience",
  "What roles is he suited for?",
  "What makes him unique?",
  "His leadership style",
  "Technical capabilities",
  "Tell me about his work at Presence",
  "What did he do at PeerTeach?",
  "What are his key metrics and achievements?",
  "Why should I hire him?",
  "What's his availability?",
  "Tell me about his projects"
];

export const userInteractions = {
  questions: [],

  logQuestion: (question, response, timestamp) => {
  userInteractions.questions.push({
  question,
  response,
  timestamp: timestamp || new Date().toISOString()
  });
  },

  getQuestionAnalytics: () => {
  return userInteractions.questions;
  }
};
